var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "answer_wrap",
      style: {
        height: _vm.currentValue.isShowMore ? "auto" : "auto"
      }
    },
    [
      _c("div", { staticClass: "answer_title" }, [
        _c("div", { staticClass: "tips" }, [
          _vm._v(_vm._s(_vm.currentValue.questionTypeName))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "title_wrap" }, [
          _c("div", { staticStyle: { position: "absolute" } }, [
            _vm.filterUserAnswerStatus(_vm.currentValue) == 1
              ? _c("div", { staticClass: "status success" }, [
                  _c("img", {
                    attrs: {
                      src: require("../../assets/image/learnmodel/V@2x.png"),
                      alt: ""
                    }
                  }),
                  _vm._v("\n                      正确\n                  ")
                ])
              : _vm.filterUserAnswerStatus(_vm.currentValue) == 0
              ? _c("div", { staticClass: "status error" }, [
                  _c("img", {
                    attrs: {
                      src: require("../../assets/image/learnmodel/cuo@2x.png"),
                      alt: ""
                    }
                  }),
                  _vm._v("\n                      错误\n                  ")
                ])
              : _vm.filterUserAnswerStatus(_vm.currentValue) == 2
              ? _c("div", { staticClass: "status" })
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", {
            staticClass: "title",
            domProps: { innerHTML: _vm._s(_vm.currentValue.questionContent) }
          })
        ])
      ]),
      _vm._v(" "),
      _vm.currentValue.internalTypeId == 1
        ? _c(
            "div",
            { staticStyle: { "padding-top": "10px" } },
            [
              _c(
                "el-radio-group",
                {
                  on: { change: _vm.submit },
                  model: {
                    value: _vm.content,
                    callback: function($$v) {
                      _vm.content = $$v
                    },
                    expression: "content"
                  }
                },
                _vm._l(_vm.currentValue.items, function(item, index) {
                  return _c(
                    "el-radio",
                    { key: index, attrs: { label: item.itemKey } },
                    [
                      _vm._v(
                        _vm._s(
                          item.itemKey + "、" + _vm.filterC(item.itemValue)
                        ) + "\n              "
                      )
                    ]
                  )
                }),
                1
              )
            ],
            1
          )
        : _vm.currentValue.internalTypeId == 3
        ? _c(
            "div",
            { staticClass: "judge", staticStyle: { "padding-top": "10px" } },
            [
              _c(
                "el-radio-group",
                {
                  on: { change: _vm.submit },
                  model: {
                    value: _vm.content,
                    callback: function($$v) {
                      _vm.content = $$v
                    },
                    expression: "content"
                  }
                },
                [
                  _c("el-radio", { attrs: { label: "正确" } }, [
                    _c("i", { staticClass: "el-icon-check" })
                  ]),
                  _vm._v(" "),
                  _c("el-radio", { attrs: { label: "错误" } }, [
                    _c("i", { staticClass: "el-icon-close" })
                  ])
                ],
                1
              )
            ],
            1
          )
        : _vm.currentValue.internalTypeId == 2
        ? _c(
            "div",
            { staticStyle: { "padding-top": "10px" } },
            [
              _c(
                "el-checkbox-group",
                {
                  on: { change: _vm.submit },
                  model: {
                    value: _vm.content,
                    callback: function($$v) {
                      _vm.content = $$v
                    },
                    expression: "content"
                  }
                },
                _vm._l(_vm.currentValue.items, function(item, index) {
                  return _c(
                    "el-checkbox",
                    {
                      key: index,
                      class: _vm.errFilter(index) ? "errStyle" : "",
                      attrs: { label: item.itemKey }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          item.itemKey + "、" + _vm.filterC(item.itemValue)
                        ) + "\n              "
                      )
                    ]
                  )
                }),
                1
              )
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9ddd1dac", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9ddd1dac","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/component/answer.vue
// module id = null
// module chunks = 